import * as React from 'react'
import { useMemo } from 'react'

import { Transport } from '@connectrpc/connect'
import { RouterProvider, RouterProviderProps } from 'react-router/dom'

type AppRouterProviderProps = {
  transport: Transport
  createRouter: (transport: Transport) => RouterProviderProps['router']
} & Omit<RouterProviderProps, 'router'>

const AppRouterProvider: React.FC<AppRouterProviderProps> = ({
  transport,
  createRouter,
  ...rest
}) => {
  const router = useMemo(() => {
    return createRouter(transport)
  }, [transport, createRouter])

  return <RouterProvider router={router} {...rest} />
}

export default AppRouterProvider
